
import React, { useEffect } from "react";
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import BackgroundHome from "./BackgroundGradient";
import award from '../data/images/award.png';

export default function HomeBanner() {
	const locale = useSelector((state) => state.globalContent.data.locale);
	const user = useSelector((state) => state.user.data);
	const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const balanceCutOff = 15;

	function totalBalance() {
        const real = parseFloat(user.wagerBalance) + parseFloat(user.withdrawableBalance);
        const bonus = parseFloat(user.bonus[0]?.bonusDepositBalance || 0) + parseFloat(user.bonus[0]?.bonusDepositWinnings || 0) + parseFloat(user.bonus[0]?.bonusFreeBalance || 0) + parseFloat(user.bonus[0]?.bonusFreeWinnings || 0);
        return parseFloat(real) + parseFloat(bonus);
    }

	useEffect(() => { })

	return (
		<Container fluid className="home-banner-container section-margin">
			{/* <div className="home-banner-image"></div> */}
			<Container className="home-banner-wrapper">
				<div className="home-banner-text">
					{
						userLoggedIn && user?.firstName?.length > 0 ? (
							<h1 className='title white-100 mb-1' >{`Welcome, ${user.firstName}`}</h1>
						) : (
							<h1 className='title white-100 mb-1' >Welcome to Cherry Spins!</h1>
						)
					}
					{
						userLoggedIn && (parseFloat(totalBalance()) > balanceCutOff) && (
							<p className='h4 white-87' >Best of luck today!</p>
						)
					}
					{
						userLoggedIn && (parseFloat(totalBalance()) < balanceCutOff) && (
							<div>
								<p className='h4 white-87' >Time to top up your balance!</p>
								<Link to={`/${locale}/profile/deposit`} className="btn btn-main mt-3">Deposit now</Link>
							</div>
						)
					}
					{
						!userLoggedIn && (
							<p className='h4 mid-emphasis'>Today is your lucky day!</p>
						)
					}
				</div>
				{
					!userLoggedIn && (
						<div className="home-banner-award">
							{/* <img src={award} /> */}
							<img src="https://cherryspins.b-cdn.net/images/award.png" />
						</div>
					)
				}
			</Container>
		</Container>
	);
}